import PropTypes from 'prop-types';

function HelperDetailListItem(props) {
  return (
    <div className="HelperDetailList-row">
      {props.icon && (
        <div className="HelperDetailList-cell">
          <img className="HelperDetailList-icon" src={props.icon} alt="" />
        </div>
      )}
      <div className={`HelperDetailList-cell HelperDetailList-info${props.isOverlay ? '--overlay' : ''}`}>
        <div className="HelperDetailList-title">{props.title}</div>
        {props.info}
        {props.link && (
          <div className="HelperDetailList__link">{props.link}</div>
        )}
      </div>
    </div>
  );
}

HelperDetailListItem.defaultProps = {
  isOverlay: false,
};

HelperDetailListItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.node,
  info: PropTypes.string.isRequired,
  isOverlay: PropTypes.bool,
};

export default HelperDetailListItem;
